




























































import WeboLogoSvg from "@/assets/svg/webo-logo.svg";
import DropdownArrowsSvg from "@/assets/svg/dropdown-arrows.svg";
import { Component, Vue } from "vue-property-decorator";
import BaseBreadcrumbs from "@/resources/components/BaseBreadcrumbs.vue";
import Station from "@/app/models/Station";

@Component({
    components: {WeboLogoSvg, DropdownArrowsSvg, BaseBreadcrumbs},
})
export default class BaseLayout extends Vue {
    private dropdownOpened: boolean = false;

    get station(): Station|null {
        return this.$store.state.data.station;
    }

    private toggleDropdown(): void {
        this.dropdownOpened = !this.dropdownOpened;
    }

    private async onLogout(): Promise<void> {
        this.$set(this.$root, 'user', {});
        this.dropdownOpened = false;

        await this.$store.commit('data/setStation', null);
        await this.$store.dispatch('auth/logout');
        await this.$router.replace({name: 'login'});
    }
}
